import React, { useState, useEffect } from 'react';
import { GetAllVosUploads_getAllVosUploads as VosInfo, GetMobDemobFormExportDownload } from '../../../types/schemaTypes';
import VosModal from './VosModal';
import './DashboardVos.scss';
import { GET_ASSETS_FOR_MOB_DEMOB_FORM_DOWNLOAD } from '../../../graphql/client/queries';
import { Parser } from '@json2csv/plainjs';
import { useLazyQuery } from '@apollo/client/react';
import moment from 'moment';
import { Loading } from '../../_common';

interface DashboardVosItemProps {
    vos: VosInfo;
    index: number;
    downloadFormData: () => void;
}

const DashboardVosItem = ({ vos, index, downloadFormData }: DashboardVosItemProps): React.ReactElement => {
    const {
        jobId,
        wellName,
        district,
        customer,
        week1,
        week2,
        week3,
        week4,
        week5,
        week6,
        downloadLinkDemob,
        downloadLinkMob,
        downloadLinkWeek1,
        downloadLinkWeek2,
        downloadLinkWeek3,
        downloadLinkWeek4,
        downloadLinkWeek5,
        downloadLinkWeek6,
    } = vos;
    const isOdd = index % 2 == 1;
    const containerStyle = `VosItem-Header-Container ${!isOdd && 'VosItem-Header-Container-With-Background'}`;
    const [isMobDownload, setIsMobDownload] = useState(false);

    const [exportToMobDemobFormCSV, { data: MobDemobFormData, loading: MobDemobFormLoding, error }] = useLazyQuery<GetMobDemobFormExportDownload>(
        GET_ASSETS_FOR_MOB_DEMOB_FORM_DOWNLOAD,
        { fetchPolicy: 'network-only' },
    );

    useEffect(() => {
        if (!MobDemobFormLoding && MobDemobFormData) {
            if ((MobDemobFormData.getMobDemobFormExportDownload?.length ?? 0) > 0) {
                downloadHandlerForMobDemobFormDataCSV(MobDemobFormData);
            } else {
                downloadFormData();
            }
        }
    }, [MobDemobFormLoding, MobDemobFormData]);

    const downloadMobDemobForm = (isMobDemob: any) => {
        isMobDemob === 1 ? setIsMobDownload(true) : setIsMobDownload(false);
        exportToMobDemobFormCSV({
            variables: {
                input: {
                    jobIds: jobId,
                    regionIds: [],
                    statuses: [],
                    loadTypeIds: [],
                    drivers: [],
                    carriers: [],
                    equipmentId: '',
                    equipmentTypeIds: [],
                    trailerTypeIds: [],
                    atDestinationOutFrom: '',
                    atDestinationOutTo: '',
                    isSearchOnLoadId: false,
                    search: '',
                    sortOrder: '',
                    isKronosExport: false,
                    isMobFormExport: isMobDemob,
                },
            },
        });
    };

    const downloadHandlerForMobDemobFormDataCSV = (data) => {
        if (data && data?.getMobDemobFormExportDownload) {
            // alert(`data${JSON.stringify(data.getFilteredAssetLoadManagements[0])}`)
            const data1 = data?.getMobDemobFormExportDownload.map((assets, index) => {
                return {
                    'No.': ++index,
                    'Customer Name': assets?.customer,
                    'Job Name': assets?.jobName,
                    'Date': moment(assets?.atDestinationOut).format("YYYY/MM/DD"),
                    'Load Number': assets?.loadId,
                    'Equipment Type': assets?.equipments,
                    'Quantity': assets?.quantity,
                    'Origin Name': assets?.originAddress,
                    'Destination Name': assets?.destinationAddress,
                    'Mileage': assets?.miles !== 0 ? assets?.miles : '',// changes to be made in graphQl to handle miles value if it is 0.
                };
            });

            const opts = {};
            const parser = new Parser(opts);
            const csvData = parser.parse(data1);
            const file = new Blob([csvData], { type: 'application/csv' });
            const url = window.URL.createObjectURL(file);
            const a = document.createElement('a');
            a.href = url;
            a.download = `MobDemobFormData.csv`;
            a.click();
        }
    };


    return (
        <div className={containerStyle}>
            <div className="d-flex flex-column justify-content-between col-md-2">
                <div className="VosItem-Header-Content">{wellName}</div>
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <div className="VosItem-Header-Content">{district}</div>
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <div className="VosItem-Header-Content">{customer}</div>
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <div onClick={() => downloadMobDemobForm(1)} className={` ${'GridViewItem-Edit-Container'}`}>
                    <span style={{ marginLeft: '15px', marginTop: '10px' }} className="UsersItem-Link">
                        {MobDemobFormLoding && isMobDownload && <div className="Vos-Spinner"><Loading /></div>}
                        Download
                    </span>
                </div>
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week1 ? week1 : ''}
                    downloadLink={downloadLinkWeek1 ? downloadLinkWeek1 : ''}
                    imageName={`Week1 ${week1 ? week1 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week2 ? week2 : ''}
                    downloadLink={downloadLinkWeek2 ? downloadLinkWeek2 : ''}
                    imageName={`Week2 ${week2 ? week2 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week3 ? week3 : ''}
                    downloadLink={downloadLinkWeek3 ? downloadLinkWeek3 : ''}
                    imageName={`Week3 ${week3 ? week3 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week4 ? week4 : ''}
                    downloadLink={downloadLinkWeek4 ? downloadLinkWeek4 : ''}
                    imageName={`Week4 ${week4 ? week4 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week5 ? week5 : ''}
                    downloadLink={downloadLinkWeek5 ? downloadLinkWeek5 : ''}
                    imageName={`Week5 ${week5 ? week5 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <VosModal
                    week={week6 ? week6 : ''}
                    downloadLink={downloadLinkWeek6 ? downloadLinkWeek6 : ''}
                    imageName={`Week6 ${week6 ? week6 : ''} `}
                />
            </div>
            <div className="d-flex flex-column justify-content-between col-md-1">
                <div onClick={() => downloadMobDemobForm(2)} className={` ${'GridViewItem-Edit-Container'}`}>
                    <span style={{ marginLeft: '15px', marginTop: '10px' }} className="UsersItem-Link">
                        {MobDemobFormLoding && !isMobDownload && <div className="Vos-Spinner"><Loading /></div>}
                        Download
                    </span>
                </div>
            </div>
        </div>
    );
};

export default DashboardVosItem;

